/**
 * slotHandler
 *
 * The slotHandler provides methods for getting slot-Texts in methods and for forwarding the appropriate slots to the child component.
 * The variable e.g. 'ShoppingCart' determines which suffix the slot must have in order for it to be passed on.
 * This suffix is then cut off and the slot is passed on. The slot gets shorter from child component to child component.
 *
 * Example:
 *          <template v-for="slot in possibleChildSlotsFor('ShoppingCart')" v-slot:[`${slot.child}`]>
 *           <slot :name="`${slot.parent}`"></slot>
 *         </template>
 *
 * Example: Without Cutting
 *
 * Slots may be used in multiple child components, and you don't want the suffix to be cut off.
 * In this case, the suffix must not be truncated at the end of the slot.
 *
 *         <template v-for="slot in possibleChildSlotsFor('ShoppingCart')" v-slot:[`${slot.parent}`]>
 *           <slot :name="`${slot.parent}`"></slot>
 *         </template>
 *
 */

const matchingChild = (key) => (childAppendix) => {
  return key.endsWith(childAppendix)
}

const possibleSlots = (slots, keys) => {
  return Object.keys(slots)
    .filter(key => {
      return keys.find(matchingChild(key))
    })
    .map(key => {
      const childAppendix = keys.find(matchingChild(key))
      return {
        parent: key,
        child: key.slice(0, -childAppendix.length)
      }
    })
}

export default function slotHandler () {
  return {
    /* Use this for debugging locally to see if your slots work
    computed: {
      allSlots: function () {
        return this.$slots
      }
    }, */
    methods: {
      getSlotText (name, defaultText = '') {
        let text = ''
        if (typeof this.$slots[name] !== 'undefined' && Array.isArray(this.$slots[name]) && this.$slots[name][0]) {
          text = this.$slots[name].map(el => {
            if (typeof el.tag === 'undefined') {
              return el.text ? el.text : ''
            } else {
              const innerHtml = (el.data?.domProps?.innerHTML || '').trim()
              const tag = document.createElement(el.tag)
              tag.setAttribute('style', el.data?.attrs?.style)
              tag.setAttribute('class', el.data?.attrs?.class)
              tag.innerHTML = innerHtml
              return tag.outerHTML
            }
          }).join('')
          return text
        }
        return defaultText
      },
      /**  checks if slot is not empty */
      isSlotNotEmpty (name) {
        return this.getSlotText(name) !== ''
      },
      /** converts a list in an array */
      getSlotListToArray (name) {
        const innerHtml = (this.$slots[name]?.filter(test => test.tag)?.[0]?.data?.domProps?.innerHTML || '').trim()
        const template = document.createElement('template')
        template.innerHTML = innerHtml
        return [...template.content.children].map(child => {
          return {
            key: child.textContent,
            value: child.textContent
          }
        })
      },
      possibleChildSlotsFor (key, dynamic = null) {
        return [
          ...possibleSlots(this.$slots, [key]),
          ...((dynamic !== null) ? possibleSlots(this.$slots, [`${key}${dynamic}`]) : [])
        ]
      }
    }
  }
}
